module.exports = __webpack_public_path__ + "img/freespin_feature.7266632f.png";